// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ForgotPassword_container__vXCLl{
    display: flex;
    flex-direction: row-reverse;
    height: 100%;
    padding-top: 30px;
}
.ForgotPassword_banner__FRtPy{
    height: calc(100vh - 154px);
    width: 40%;
    padding-bottom: 50px;
}
@media(max-width: 1180px){
    .ForgotPassword_container__vXCLl{
        display: block;
        height: auto;
    }
    .ForgotPassword_banner__FRtPy{
        display: flex;
        flex-direction: column-reverse;
        width: 100%;
        margin-top: -25px;
    }
}
@media(max-width: 600px){
    .ForgotPassword_container__vXCLl{
        padding-top: 0;
    }
}
.ForgotPassword_bottomBar__0XgI0{
    display: flex;
    align-items: center;
    margin-top: -5px;
    padding: 20px 25px 20px 30px;
    background-color: #40798C;
    border-radius: 0 0 30px 30px;
}
@media(max-width: 1180px){
    .ForgotPassword_bottomBar__0XgI0{
        margin-top: -5px;
        padding-bottom: 50px;
        border-radius: 30px 30px 0 0;
    }
}
@media(max-width: 480px){
    .ForgotPassword_bottomBar__0XgI0{
        flex-direction: column;
        padding: 25px 25px 60px 25px;
    }
}
.ForgotPassword_bottomBarText__K-nLL{
    margin-right: 25px;
    font-size: 31px;
    color: #FFFFFF;
    line-height: 31px;
}
.ForgotPassword_image__BthD0{
    height: calc(100% - 88px);
    width: 100%;
    border-radius: 30px 30px 0 0;
    object-fit: cover;
}
@media(max-width: 1180px){
    .ForgotPassword_image__BthD0{
        margin-top: -30px;
        object-position: top;
    }
}
.ForgotPassword_loginButton__s8Tut{
    min-width: 108px;
    margin-left: auto;
}
@media(max-width: 480px){
    .ForgotPassword_loginButton__s8Tut{
        width: calc(100% - 90px);
        margin-top: 20px;
    }
}
.ForgotPassword_formContainer__uSD-U{
    display: flex;
    justify-content: center;
    height: calc(100vh - 174px);
    width: 60%;
    padding-top: 70px;
    overflow-y: auto;
    overflow-x: hidden;
}
@media(max-width: 1180px){
    .ForgotPassword_formContainer__uSD-U{
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        height: 500px;
        width: 500px;
        padding-top: 0;
    }
}
@media(max-width: 600px){
    .ForgotPassword_formContainer__uSD-U{
        height: auto;
        width: calc(100% - 30px);
        margin: 30px 15px 120px 15px;
    }
}
.ForgotPassword_form__wddSj{
    width: 500px;
}
.ForgotPassword_formNamesRow__lsBkm{
    display: flex;
}
.ForgotPassword_header__bTpHz{
    text-align: left !important;
    word-break: normal;
}
.ForgotPassword_description__eXmi2{
    margin-top: -12px;
    margin-bottom: 45px;
    padding-left: 2px;
}
.ForgotPassword_name__\\+QbM7 input{
    width: 190px;
}
.ForgotPassword_singleLineInput__OS9Ca{
    display: block !important;
    margin-top: 15px;
}
.ForgotPassword_singleLineInput__OS9Ca input{
    width: calc(100% - 40px);
}
@media(max-width: 600px){
    .ForgotPassword_form__wddSj{
        width: 100%;
    }
    .ForgotPassword_formNamesRow__lsBkm{
        display: block;
    }
    .ForgotPassword_name__\\+QbM7{
        display: block !important;
        margin-top: 15px;
    }
    .ForgotPassword_name__\\+QbM7 input{
        width: calc(100% - 45px);
    }
    .ForgotPassword_singleLineInput__OS9Ca input{
        width: calc(100% - 45px);
    }
}
.ForgotPassword_formBottom__ipOgV{
    display: flex;
    align-items: center;
    margin-top: 50px;
}
.ForgotPassword_shieldCheckmark__OQuFQ{
    height: 60px;
    width: 51px;
}
.ForgotPassword_resetSuccessfulHeader__1D\\+cb{
    margin-top: 35px;
    margin-bottom: 25px;
    font-size: 31px;
    font-family: "Gotham Bold", serif;
}`, "",{"version":3,"sources":["webpack://./src/pages/ForgotPassword.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2BAA2B;IAC3B,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,2BAA2B;IAC3B,UAAU;IACV,oBAAoB;AACxB;AACA;IACI;QACI,cAAc;QACd,YAAY;IAChB;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,WAAW;QACX,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,cAAc;IAClB;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI;QACI,gBAAgB;QAChB,oBAAoB;QACpB,4BAA4B;IAChC;AACJ;AACA;IACI;QACI,sBAAsB;QACtB,4BAA4B;IAChC;AACJ;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,4BAA4B;IAC5B,iBAAiB;AACrB;AACA;IACI;QACI,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI;QACI,wBAAwB;QACxB,gBAAgB;IACpB;AACJ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,2BAA2B;IAC3B,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI;QACI,OAAO;QACP,QAAQ;QACR,iBAAiB;QACjB,kBAAkB;QAClB,aAAa;QACb,YAAY;QACZ,cAAc;IAClB;AACJ;AACA;IACI;QACI,YAAY;QACZ,wBAAwB;QACxB,4BAA4B;IAChC;AACJ;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI;QACI,WAAW;IACf;IACA;QACI,cAAc;IAClB;IACA;QACI,yBAAyB;QACzB,gBAAgB;IACpB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,iCAAiC;AACrC","sourcesContent":[".container{\n    display: flex;\n    flex-direction: row-reverse;\n    height: 100%;\n    padding-top: 30px;\n}\n.banner{\n    height: calc(100vh - 154px);\n    width: 40%;\n    padding-bottom: 50px;\n}\n@media(max-width: 1180px){\n    .container{\n        display: block;\n        height: auto;\n    }\n    .banner{\n        display: flex;\n        flex-direction: column-reverse;\n        width: 100%;\n        margin-top: -25px;\n    }\n}\n@media(max-width: 600px){\n    .container{\n        padding-top: 0;\n    }\n}\n.bottomBar{\n    display: flex;\n    align-items: center;\n    margin-top: -5px;\n    padding: 20px 25px 20px 30px;\n    background-color: #40798C;\n    border-radius: 0 0 30px 30px;\n}\n@media(max-width: 1180px){\n    .bottomBar{\n        margin-top: -5px;\n        padding-bottom: 50px;\n        border-radius: 30px 30px 0 0;\n    }\n}\n@media(max-width: 480px){\n    .bottomBar{\n        flex-direction: column;\n        padding: 25px 25px 60px 25px;\n    }\n}\n.bottomBarText{\n    margin-right: 25px;\n    font-size: 31px;\n    color: #FFFFFF;\n    line-height: 31px;\n}\n.image{\n    height: calc(100% - 88px);\n    width: 100%;\n    border-radius: 30px 30px 0 0;\n    object-fit: cover;\n}\n@media(max-width: 1180px){\n    .image{\n        margin-top: -30px;\n        object-position: top;\n    }\n}\n.loginButton{\n    min-width: 108px;\n    margin-left: auto;\n}\n@media(max-width: 480px){\n    .loginButton{\n        width: calc(100% - 90px);\n        margin-top: 20px;\n    }\n}\n.formContainer{\n    display: flex;\n    justify-content: center;\n    height: calc(100vh - 174px);\n    width: 60%;\n    padding-top: 70px;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n@media(max-width: 1180px){\n    .formContainer{\n        left: 0;\n        right: 0;\n        margin-left: auto;\n        margin-right: auto;\n        height: 500px;\n        width: 500px;\n        padding-top: 0;\n    }\n}\n@media(max-width: 600px){\n    .formContainer{\n        height: auto;\n        width: calc(100% - 30px);\n        margin: 30px 15px 120px 15px;\n    }\n}\n.form{\n    width: 500px;\n}\n.formNamesRow{\n    display: flex;\n}\n.header{\n    text-align: left !important;\n    word-break: normal;\n}\n.description{\n    margin-top: -12px;\n    margin-bottom: 45px;\n    padding-left: 2px;\n}\n.name input{\n    width: 190px;\n}\n.singleLineInput{\n    display: block !important;\n    margin-top: 15px;\n}\n.singleLineInput input{\n    width: calc(100% - 40px);\n}\n@media(max-width: 600px){\n    .form{\n        width: 100%;\n    }\n    .formNamesRow{\n        display: block;\n    }\n    .name{\n        display: block !important;\n        margin-top: 15px;\n    }\n    .name input{\n        width: calc(100% - 45px);\n    }\n    .singleLineInput input{\n        width: calc(100% - 45px);\n    }\n}\n.formBottom{\n    display: flex;\n    align-items: center;\n    margin-top: 50px;\n}\n.shieldCheckmark{\n    height: 60px;\n    width: 51px;\n}\n.resetSuccessfulHeader{\n    margin-top: 35px;\n    margin-bottom: 25px;\n    font-size: 31px;\n    font-family: \"Gotham Bold\", serif;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ForgotPassword_container__vXCLl`,
	"banner": `ForgotPassword_banner__FRtPy`,
	"bottomBar": `ForgotPassword_bottomBar__0XgI0`,
	"bottomBarText": `ForgotPassword_bottomBarText__K-nLL`,
	"image": `ForgotPassword_image__BthD0`,
	"loginButton": `ForgotPassword_loginButton__s8Tut`,
	"formContainer": `ForgotPassword_formContainer__uSD-U`,
	"form": `ForgotPassword_form__wddSj`,
	"formNamesRow": `ForgotPassword_formNamesRow__lsBkm`,
	"header": `ForgotPassword_header__bTpHz`,
	"description": `ForgotPassword_description__eXmi2`,
	"name": `ForgotPassword_name__+QbM7`,
	"singleLineInput": `ForgotPassword_singleLineInput__OS9Ca`,
	"formBottom": `ForgotPassword_formBottom__ipOgV`,
	"shieldCheckmark": `ForgotPassword_shieldCheckmark__OQuFQ`,
	"resetSuccessfulHeader": `ForgotPassword_resetSuccessfulHeader__1D+cb`
};
export default ___CSS_LOADER_EXPORT___;
